import { render } from "./EmployeeSupervisors.vue?vue&type=template&id=3d6220aa&scoped=true"
import script from "./EmployeeSupervisors.vue?vue&type=script&lang=js"
export * from "./EmployeeSupervisors.vue?vue&type=script&lang=js"

import "./EmployeeSupervisors.vue?vue&type=style&index=0&id=3d6220aa&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6220aa"]])

export default __exports__